import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { NovoRepresentanteMultiSelectComponent } from './novo-representante-multi-select.component';

@NgModule({
  imports: [SharedModule],
  declarations: [NovoRepresentanteMultiSelectComponent],
  exports: [NovoRepresentanteMultiSelectComponent]
})
export class NovoRepresentanteMultiSelectModule {}
